import { Link } from 'react-router-dom';
import { useOrgProjects } from '../../lib/useOrgProjects.js';
import { Card } from '../../components/ui/Card.js';

/** A project's timeline is inherently project-scoped (it needs that project's tasks and
 * dependency graph) — this landing page is just the "pick a project" step before /projects/:id/timeline. */
export function TimelineLandingPage() {
  const { data: projects, loading, error } = useOrgProjects();

  return (
    <div className="mx-auto flex max-w-lg flex-col gap-4 p-4 sm:p-6">
      <h1 className="text-lg font-semibold">Timeline</h1>
      {error ? (
        <Card className="p-6 text-center text-sm text-danger sm:p-8">
          Couldn't load projects: {error.message}
        </Card>
      ) : loading ? (
        <p className="text-sm text-muted">Loading…</p>
      ) : projects.length === 0 ? (
        <Card className="p-6 text-center text-sm text-muted sm:p-8">No projects yet.</Card>
      ) : (
        <Card className="flex flex-col divide-y divide-border">
          {projects.map((p) => (
            <Link
              key={p.id}
              to={`/projects/${p.id}/timeline`}
              className="break-words p-3 text-sm hover:bg-surface-2"
            >
              {p.name}
            </Link>
          ))}
        </Card>
      )}
    </div>
  );
}
